import { markSubmittalAsCompleted } from "@/api/submittal";
import { Divider } from "@/components/misc";
import { useState, useEffect } from "react";
import { CardDropdownSubmittal } from "./Utils/CardDropdown";
import { CardBase, DaysOldColor, PingedCardAlert } from "./Utils/CardHelper";
import { NotesSection } from "../ProjectProgress/Utils/NotesSection";
import { CategoryIcon } from "./Utils/CategoryIcon";
import { TitleHeaderHyperlink } from "./Utils/TitleHeaderHyperlink";
import { SubmittalProps } from "@/interfaces/submittal_types";
import { useNavigate, useLocation } from "react-router-dom";

type SubmittalCardProps = {
    submittal: SubmittalProps,
    isNew: boolean,
    onView: () => void
}

export function SubmittalCard({ submittal, isNew, onView }: SubmittalCardProps) {
    const [isNewLocal, setIsNewLocal] = useState(isNew);
    const navigate = useNavigate()
    const location = useLocation()
    const folder_location = `${submittal.folder_location}`;

    const handleMark = async () => {
        if (confirm("Are you sure you want to mark this submittal as closed?")) {
            if (submittal.submittal_id) {
                const response = await markSubmittalAsCompleted(submittal.submittal_id)
                if (response.operation === "COMPLETED") {
                    navigate(location.pathname, { replace: true })
                }
            } else {
                alert("Submittal ID is not defined")
            }
        }
    };

    useEffect(() => {
        if (isNewLocal) {
            setIsNewLocal(true);
            onView();
        }
    }, [isNewLocal, onView]);

    return (
        <CardBase
            isNew={isNewLocal}
            isOverdue={submittal.alert_status ?? false}
            hoverChildren={<CardDropdownSubmittal
                edit_submittal_route={`/submittals/update_submittal/${submittal.submittal_id}`}
                folder_path={folder_location}
                parent_project_folder_location={submittal.parent_project_folder_location ?? ''}
                category={submittal.category}
                mark_as_completed_fn={handleMark} />}
        >
            {submittal.alert_status && <PingedCardAlert text="Please complete this submittal soon. It is overdue." />}
            <div className="flex flex-row items-center">
                <CategoryIcon category={submittal.category} />
                <TitleHeaderHyperlink title={submittal.project_name ?? 'Project Name Not Found'} folder_location={folder_location} />
            </div>

            <Divider />

            <NotesSection notes={submittal.sub_description ?? ''} />

            <div className="flex flex-row justify-between">
                <p>Received: {submittal.received_date}</p>
                <p>Days Old: <span className={DaysOldColor(submittal.days_old ?? 0)}>{submittal.days_old}</span></p>
            </div>

        </CardBase>
    )
}
